export default "__VITE_ASSET__CKS3Z_4Q__"